/*
 * Template placeholder and logo utilities.
 */

/**
 * Get text direction based on current language (for RTL/LTR).
 * @param {Function} getLanguage - e.g. () => i18n.getLanguage()
 * @returns {'rtl'|'ltr'}
 */
export function getTextDirection(getLanguage) {
  const lang = getLanguage ? getLanguage() : (typeof window !== "undefined" && window.i18n?.getLanguage?.()) || "en";
  return lang.startsWith("ar") ? "rtl" : "ltr";
}

/**
 * Extract all placeholders from text (e.g. {{NAME}}, {{GROUP_NAME}}).
 * Excludes DATE, TIME, YEAR, DATETIME as they're handled by Outlook.
 */
export function extractPlaceholders(text) {
  if (!text) return [];
  const matches = text.match(/\{\{(\w+)\}\}/g);
  if (!matches) return [];
  const autoHandled = ["DATE", "TIME", "YEAR", "DATETIME"];
  const unique = [...new Set(matches.map((m) => m.replace(/\{\{|\}\}/g, "").toUpperCase()))].filter(
    (p) => !autoHandled.includes(p)
  );
  return unique;
}

/**
 * Substitute {{PLACEHOLDER}} in text with variables. Falls back to defaultVars if provided.
 */
export function substitutePlaceholders(text, variables = {}, defaultVars = {}) {
  if (!text) return text;
  const merged = { ...defaultVars, ...variables };
  return text.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const upperKey = key.toUpperCase();
    if (variables[upperKey] !== undefined) return variables[upperKey];
    return defaultVars[upperKey] !== undefined ? defaultVars[upperKey] : match;
  });
}

/**
 * Extract logo URL placeholders (e.g. {{LOGO_URL_1}}, {{LOGO_URL_2}}).
 */
export function extractLogoPlaceholders(text) {
  if (!text) return [];
  const matches = text.match(/\{\{LOGO_URL(_\d+)?\}\}/gi);
  if (!matches) return [];
  return [...new Set(matches.map((m) => m.replace(/\{\{|\}\}/gi, "").toUpperCase()))];
}

/**
 * Replace logo placeholders in text with actual URLs from logoUrls object.
 */
export function replaceLogoPlaceholders(text, logoUrls) {
  if (!text) return text;
  let result = text;
  Object.keys(logoUrls || {}).forEach((logoKey) => {
    const regex = new RegExp(`\\{\\{${logoKey}\\}\\}`, "gi");
    result = result.replace(regex, logoUrls[logoKey] || "");
  });
  return result;
}
